<template>
  <div
    class="item-product-type-wrapper"
    :style="{ flexDirection: orientation }">
    <div
      v-for="item in typesToRendering"
      :key="item.title"
      class="item-product-type-wrapper__item">
      <span
        :style="`background-color: ${item.color}`">
        {{ item.title }}
      </span>
    </div>
    <p
      v-if="typesLength > MAX_TYPES_TO_RENDER"
      class="item-product-type-wrapper__additional-type-count">
      ... + {{ typesLength - MAX_TYPES_TO_RENDER }}
    </p>
  </div>
</template>

<script>
import json from '@/components/Product/ProductCell/ProductCellDropdownV2/customDropdownsColors';
import productHeaders from '@/constants/productHeaders';

const MAX_TYPES_TO_RENDER = 3;
export default {
  name: 'ElementProductType',
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    orientation: {
      type: String,
      default: 'column',
    },
  },
  data() {
    return {
      json,
      MAX_TYPES_TO_RENDER,
    };
  },
  computed: {
    checkedTypes() {
      const { types } = this;
      if (!Array.isArray(types) || !types) return [];
      return types;
    },
    limitedTypes() {
      const { checkedTypes: types } = this;
      return [...types.slice(0, MAX_TYPES_TO_RENDER)];
    },
    typesToRendering() {
      const { productTypeColorObj: obj, limitedTypes } = this;
      if (!limitedTypes.length) {
        return [];
      }
      let types = limitedTypes.map(item => {
        const itemLength = item.length;
        const colorNumber = itemLength <= 12 ? itemLength : itemLength % 12;
        return {
          title: item,
          color: obj.dropdownColors[colorNumber],
        };
      });
      return types;
    },
    typesLength() {
      const { checkedTypes: types } = this;
      return types.length;
    },
    productTypeColorObj() {
      return this.json.colors.find(el => el.string === productHeaders.PRODUCT_TYPE);
    },
  },
};
</script>

<style lang="scss" scoped>
  .item-product-type-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    &__item {
      display: grid;
      justify-content: flex-start;

      span {
        font-size: 14px;
        color: var(--v-white-base);
        padding: 5px 20px;
        border-radius: 7px;
        /* The following CSS rule was added to address an issue where the height of the 'span' element was displaying as too large on Safari.
        The 'fit-content' value for the 'height' property helps ensure that the height of the 'span' element adjusts to fit its content. */
        height: fit-content;
      }
    }

    &__additional-type-count {
      display: flex;
      align-items: flex-end;
      font-weight: bold;
      font-size: 15px;
      white-space: nowrap;
      margin-bottom: 0;
    }
  }
</style>